module.exports = __webpack_public_path__ + "files/08e22102fd7e9c0547b1f964e1021965.png";